import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import 'app/i18n';

import App from './app';
import { ConfigContextProvider } from './common/ConfigContext';
import ErrorBoundary from './common/ErrorBoundary';
import { PeriodContextProvider } from './common/PeriodContext';
import { ThemeContextProvider } from './common/ThemeContext';
import './style.scss';
import { initSentry } from './utils/sentry';
import Error from './components/Error';
import Layout from './components/Layout';
import { DisplayContextProvider } from './common/DisplayContext';

const container = document.getElementById('app');
const root = createRoot(container!);
const baseName = import.meta.env.DEV ? '' : '/v2';

// Init Sentry service for bug tracking
initSentry();

// Ensure the widget is only used as an iframe
// const isIframeContext = () => {
//   if (process.env.NODE_ENV === 'development') return true;

//   try {
//     return window.self !== window.top;
//   } catch (e) {
//     return true; // Assume it's an iframe context if there's an error
//   }
// };

// isIframeContext() &&
root.render(
  <ErrorBoundary>
    <BrowserRouter basename={baseName}>
      <Routes>
        {/* Place Route on top of ConfigContextProvider to access the entityType in the configContext */}
        <Route
          path="/:customer/:entityType"
          element={
            <ConfigContextProvider>
              <ThemeContextProvider>
                <DisplayContextProvider>
                  <PeriodContextProvider>
                    <App />
                  </PeriodContextProvider>
                </DisplayContextProvider>
              </ThemeContextProvider>
            </ConfigContextProvider>
          }
        />
        <Route
          path="/*"
          element={
            <ThemeContextProvider>
              <Layout>
                <Error sendWidgetDisplayMetrics />
              </Layout>
            </ThemeContextProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  </ErrorBoundary>
);
